import { getUserExtInfoFN } from '@/http/modules/custom'
const state = () => ({
  getUserExtInfoStore: {},
})

// getters
const getters = {}

// actions
const actions = {
    getUserExtInfoAction({ commit }) {
        return new Promise(resolve => {
          getUserExtInfoFN().then(({data}) => {
            commit('setUserExtInfo', data)
            resolve(data)
          })
        })
    }
}

// mutations
const mutations = {
    setUserExtInfo(state, data) {
        state.getUserExtInfoStore = data
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}